export const STICKY_Y_OFFSET = 300 // desktop only
